import * as _ from 'lodash';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Alert, Button, Glyphicon, Panel, Table } from 'react-bootstrap';
import { IWatrSupplementalUploadedDoc } from '@nkr/views/donors/watr/utils/watr-supplemental-uploaded-doc';

interface IProps {
    fileUploadRecords: any[];
    supplementalDocs?: IWatrSupplementalUploadedDoc[];
    onViewUploadedDocument: (fileId: number) => void;
    onViewSupplementalDocument?: (doc: IWatrSupplementalUploadedDoc) => void;
}

type UploadedDocRow =
    | { kind: 'record'; key: string; sortMoment: Moment; record: any }
    | { kind: 'supplemental'; key: string; sortMoment: Moment; doc: IWatrSupplementalUploadedDoc };

const UploadedDocumentsPanel = ({
    fileUploadRecords,
    supplementalDocs,
    onViewUploadedDocument,
    onViewSupplementalDocument
}: IProps) => {
    const recordRows: UploadedDocRow[] = (fileUploadRecords ?? []).map(f => ({
        kind: 'record',
        key: `record-${f.id}`,
        sortMoment: moment(f.uploadedDateTime),
        record: f
    }));

    const supplementalRows: UploadedDocRow[] = (supplementalDocs ?? []).map(doc => ({
        kind: 'supplemental',
        key: doc.key,
        sortMoment: doc.sortMoment,
        doc
    }));

    const fileUploadRows = _.orderBy([...recordRows, ...supplementalRows], r => r.sortMoment, ['desc']);

    return (
        <Panel eventKey='fileUploads'>
            <Panel.Heading style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Panel.Title toggle style={{ fontSize: 14 }}>Uploaded Documents</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                {fileUploadRows.length === 0 ? (
                    <Alert bsStyle='info' style={{ marginBottom: 0 }}>No documents on file for this request.</Alert>
                ) : (
                    <Table bordered condensed striped>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th style={{ textAlign: 'right' }}>Type</th>
                                <th style={{ textAlign: 'right' }}>Date</th>
                                <th>View</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fileUploadRows.map(row => {
                                if (row.kind === 'record') {
                                    const file = row.record;
                                    return (
                                        <tr key={row.key}>
                                            <td>{file.fileName}</td>
                                            <td style={{ textAlign: 'right' }}>{file.fileTypeDescription || String(file.fileType)}</td>
                                            <td style={{ textAlign: 'right' }}>{file.uploadedDateTime ? moment(file.uploadedDateTime).format('MM/DD/YY') : '—'}</td>
                                            <td>
                                                <Button
                                                    bsSize='xs'
                                                    bsStyle='link'
                                                    onClick={() => onViewUploadedDocument(file.id)}
                                                    style={{ padding: 0 }}
                                                >
                                                    <Glyphicon glyph='file' /> View
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                }

                                const doc = row.doc;
                                return (
                                    <tr key={row.key}>
                                        <td>{doc.fileName}</td>
                                        <td style={{ textAlign: 'right' }}>{doc.fileTypeDescription}</td>
                                        <td style={{ textAlign: 'right' }}>{doc.uploadedDateTime ? moment(doc.uploadedDateTime).format('MM/DD/YY') : '—'}</td>
                                        <td>
                                            <Button
                                                bsSize='xs'
                                                bsStyle='link'
                                                onClick={() => onViewSupplementalDocument?.(doc)}
                                                style={{ padding: 0 }}
                                            >
                                                <Glyphicon glyph='file' /> View
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                )}
            </Panel.Body>
        </Panel>
    );
};

export default UploadedDocumentsPanel;
